import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
/**
 * A combined cookie is a single cookie that contains information for multiple cookies within it (sub-cookies).
 * Sub-cookies can be set/get with CookieSerializers in order to store complex objects within them.
 */
class CombinedCookie {
    constructor(cookieHandler, cookie) {
        this.cookieHandler = cookieHandler;
        this.cookie = cookie;
        this.cookie.attributes = {
            path: '/',
            ...this.cookie.attributes,
        };
    }
    /**
     * Set cookie into combined cookie
     *
     * @param {Cookie} cookie
     */
    setCookie({ name, value }) {
        const data = this.readCombinedCookie();
        if (this.cookie.serializers?.[name]) {
            data[name] = this.cookie.serializers[name].serialize(value);
        }
        else {
            if (value === null || value === undefined) {
                Logger.warn(`${name} cookie value is nullish and will be set as an empty string`);
            }
            data[name] = String(value ?? '');
        }
        this.writeCombinedCookie(data);
    }
    /**
     * Remove cookie from combined cookie
     *
     * @param {string} name
     */
    removeCookie(name) {
        const data = this.readCombinedCookie();
        delete data[name];
        this.writeCombinedCookie(data);
    }
    /**
     * Get cookie from combined cookie
     *
     * @param {string} name
     */
    getCookie(name) {
        const data = this.readCombinedCookie();
        const value = data[name];
        return {
            name,
            value: this.cookie.serializers?.[name]?.deserialize(value) ?? value,
        };
    }
    readCombinedCookie() {
        const data = {};
        // eslint-disable-next-line no-unused-expressions
        this.cookieHandler.get(this.cookie.name)?.split('&').forEach(cookieItem => {
            const [key, value] = cookieItem.split('=');
            data[key] = decodeURIComponent(value);
        });
        return data;
    }
    /**
     * Write cookie data to combined cookie
     * @private
     */
    writeCombinedCookie(data) {
        this.cookieHandler.set(this.cookie.name, CombinedCookie.getEncodedData(data), this.cookie.attributes);
    }
    /**
     * Get encoded cookie data
     * @private
     */
    static getEncodedData(data) {
        return Object.entries(data).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&');
    }
}
export default CombinedCookie;
